import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Container, Progress, Row, Col } from "reactstrap";
import assessmentHeaderArrowleftImg from "../images/assessment-header-arrowleft.svg";
import { onFinishedWebView } from "../../../helper/mobile";

const AssessmentHeader = ({ progressPer, total, currentPage, isRisk }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const goBackClickHandler = () => {
    if (location.pathname === "/riskAssessment/question/userDetails" && !isRisk)
      onFinishedWebView();
    else if (location.pathname === "/dietPlan/mandatory") onFinishedWebView();
    else navigate(-1);
  };
  return (
    <Container className="diet-assessment-header-container">
      <Row>
        <Col xs={1} className="pe-0">
          <img
            src={assessmentHeaderArrowleftImg}
            alt="assessment Header Arrowleft"
            onClick={goBackClickHandler}
          />
        </Col>
        <Col className="ps-3">
          <Progress value={progressPer} />
        </Col>
        {total && (
          <Col
            xs={2}
            className="ps-0 text-center page-score"
          >{`${currentPage}  / ${total}`}</Col>
        )}
      </Row>
    </Container>
  );
};

export default AssessmentHeader;
